import { ProjectType } from "../../../types/ProjectTypes";

const storageKey = (projectType: ProjectType) => `report.tour.seen.${projectType}`;

export function hasSeenReportTour(projectType: ProjectType): boolean {
    try {
        return localStorage.getItem(storageKey(projectType)) === "1";
    } catch {
        // localStorage unavailable; treat as seen so we never nag on every load
        return true;
    }
}

export function markReportTourSeen(projectType: ProjectType) {
    try {
        localStorage.setItem(storageKey(projectType), "1");
    } catch {
        // localStorage unavailable; nothing to persist
    }
}
